<template>
  <div>
    <!-- Header: Project manager -->
    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19"/>
      <h4 class="mb-0 ml-50">Administrateurs du Projet</h4>
    </div>

    <!-- Form: Project adminitrator Form -->
    <b-form class="mt-1" @submit.prevent="onSubmit" @reset.prevent="resetForm">
      <b-row>
        <!-- Field: project manager -->
        <b-col cols="12" lg="4" md="6">
          <b-form-group label="Responsable" label-for="assignee">
            <v-select
                v-model="projectLocal.assignee_iid"
                :clearable="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="assignees"
                :reduce="(val) => val.uid"
                input-id="assignee"
                label="name"
            />
          </b-form-group>
        </b-col>

        <!-- Field: deputy project manager -->
        <b-col cols="12" lg="4" md="6">
          <b-form-group label="Adjoint" label-for="deputy">
            <v-select
                v-model="projectLocal.deputy_id"
                :clearable="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="deputies"
                :reduce="(val) => val.uid"
                input-id="deputy"
                label="name"
            />
          </b-form-group>
        </b-col>

        <!-- Field: project techniician -->
        <b-col cols="12" lg="4" md="6">
          <b-form-group label="Technicien" label-for="technician">
            <v-select
                v-model="projectLocal.technician_id"
                :clearable="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="technicians"
                :reduce="(val) => val.uid"
                input-id="technician"
                label="name"
            />
          </b-form-group>
        </b-col>

        <!-- Field: project exert -->
        <b-col cols="12" lg="4" md="6">
          <b-form-group label="Expert" label-for="expert">
            <v-select
                v-model="projectLocal.expert_id"
                :clearable="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="experts"
                :reduce="(val) => val.uid"
                input-id="expert"
                label="name"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-button
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              type="submit"
              variant="primary"
          >
            <b-spinner v-if="isLoading" small></b-spinner>
            Sauvegarder
          </b-button>
          <b-button
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              variant="outline-secondary"
              @click="() => $router.go(-1)"
          >
            Retour
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {BButton, BCol, BForm, BFormGroup, BRow, BSpinner,} from "bootstrap-vue";
import {ref, watch} from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import {useRouter} from '@core/utils/utils'

export default {
  name: "ProjectEditAssignee",
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BSpinner,
    // flatPickr,
    // BFormInput,
    vSelect,
    // BFormRadioGroup,
    // BFormCheckboxGroup,
    BButton,
  },
  props: {
    projectData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {router} = useRouter();
    const isLoading = ref(false)
    const assignees = ref([]);
    const deputies = ref([]);
    const technicians = ref([]);
    const experts = ref([]);

    //get assignees list
    const fetchAssignees = () => {
      store.dispatch("user/allUsers", {role: 'responsable_projet'}).then(users => {
        assignees.value = users;
      });
    };

    //get deputies list
    const fetchDeputies = () => {
      store.dispatch("user/allUsers", {role: 'adjoint_projet'}).then(users => {
        deputies.value = users;
      });
    };

    //get technicians list
    const fetchTechnicians = () => {
      store.dispatch("user/allUsers", {role: 'technicien_projet'}).then(users => {
        technicians.value = users;
      });
    };

    //get experts list
    const fetchExperts = () => {
      store.dispatch("user/allUsers", {role: 'expert_projet'}).then(users => {
        experts.value = users;
      });
    };

    const projectLocal = ref(JSON.parse(JSON.stringify(props.projectData)));

    const resetForm = () => {
      projectLocal.value = JSON.parse(JSON.stringify(props.projectData));
    };

    watch(
        props.projectData,
        () => {
          resetForm();
          fetchAssignees();
          fetchDeputies();
          fetchTechnicians();
          fetchExperts();
        },
        {deep: true}
    );

    watch(
        projectLocal,
        (newProjectData) => {
          if (
              newProjectData.hasOwnProperty("customer") &&
              typeof newProjectData.customer === "object"
          )
            newProjectData.customer = newProjectData.customer?.id;
        },
        {deep: true, immediate: true}
    );

    const onSubmit = () => {
      isLoading.value = true
      store
          .dispatch("project/updateProject", projectLocal.value)
          .then((response) => {
            projectLocal.value = response.resource;
            isLoading.value = false
            router.go(-1);
          })
          .catch(() => {
            isLoading.value = false
          });
    };

    fetchAssignees();
    fetchDeputies();
    fetchTechnicians();
    fetchExperts();

    return {
      isLoading,
      projectLocal,
      assignees,
      deputies,
      technicians,
      experts,
      resetForm,
      onSubmit,
      router,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
